var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.tab === "list"
        ? _c("VueGoodTable", {
            attrs: {
              isLoading: _vm.loading,
              columns: _vm.columnsConfig,
              rows: _vm.surveysMeta,
              "pagination-options": _vm.paginationOptions,
              "search-options": _vm.searchOptions
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "emptystate",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("txtSearchNoRows")) +
                          "\n    "
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "table-row",
                  fn: function(props) {
                    return [
                      props.column.isSurveyNameColumn
                        ? _c(
                            "div",
                            { staticClass: "d-flex flex-row" },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    props.formattedRow[props.column.field]
                                  ) +
                                  "\n        "
                              ),
                              _c("AttachmentsButtonIfPresent", {
                                staticClass: "ml-auto",
                                attrs: { surveyId: props.row.surveyId }
                              })
                            ],
                            1
                          )
                        : props.column.field === "actions"
                        ? _c("span", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.openSurvey(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-arrow-right" })]
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n        " +
                                _vm._s(props.formattedRow[props.column.field]) +
                                "\n      "
                            )
                          ])
                    ]
                  }
                }
              ],
              null,
              false,
              2430543827
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "survey"
        ? _c("SurveyJSComponent", {
            attrs: {
              surveyId: _vm.surveyComponentProps.surveyId,
              started: _vm.surveyComponentProps.started,
              user: _vm.surveyComponentProps.user,
              completeScreenBackButtonAction: _vm.onSurveyBack
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }